import './project-route.component.js';
import './project-route.controller.js';
import findLastUpdatedAppt from 'utils/find-last-updated-appt.js';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder.projects.details', {
    url: '/{id:[0-9]{1,100}}?open',
    views: {
      '@': {
        component: 'inkProjectRoute'
      }
    },
    resolve: {
      $title: function() {
        return 'Project details';
      },
      project: function(Project, $stateParams) {
        return Project.get($stateParams.id).then(function(response) {
          return response;
        });
      },
      open: function($stateParams) {
        return $stateParams.open;
      }
    },
    redirectTo: (trans) => {
      // getAsync tells the resolve to load
      let resolvePromise = trans.injector().getAsync('project');
      return resolvePromise.then(function(project) {
        if (project.appointments.length) {
          const currentAppointment =
          findLastUpdatedAppt(project.appointments);
          return {
            state: 'inkfinder.appointments.details',
            params: {appointment_id: currentAppointment.id}
          };
        }
        return;
      });
    }
  });
});



// WEBPACK FOOTER //
// ./routes/project/index.js